import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BaseDialog from "../../components/BaseDialog";
import { Box, Button, Grid2 as Grid, Skeleton, Typography } from "@mui/material";

import useApi from "../../api";
import { consultarEstancia } from "../../api/controlador";
import DataLabel from "../../components/DataLabel";
import { renderTipoTag } from "../tags/ListadoRegistrosTag";
import { formatDateInYear } from "../../components/Formatter";
import Panel from "../../components/Panel";

const LoadingSkeleton = () => {
    return (
        <>
            <Skeleton key="1" variant="rounded" animation="wave" height={44} />
            <Grid key="2" container spacing={2} sx={{ mt: 1, mb: 1 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Skeleton variant="rounded" animation="wave" height={200} />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Skeleton variant="rounded" animation="wave" height={200} />
                </Grid>
            </Grid>
            <Skeleton key="3" variant="rounded" animation="wave" height={44} />
        </>
    )
}

const DetalleEstanciaDialog = ({ ...props }) => {

    let { state } = useLocation();
    const navigate = useNavigate();

    const { estanciaId } = useParams();
    const { tag } = state;

    const [open, setOpen] = useState(true);

    const [estancia, setEstancia] = useState(null);

    const [{ data: estanciaData, loading: loadingEstancia }, estanciaApi] = useApi();

    useEffect(() => {
        if (estanciaId) {
            estanciaApi(consultarEstancia(estanciaId));
        }
    }, [estanciaId]);

    useEffect(() => {
        if (estanciaData) {
            setEstancia(estanciaData);
        }
    }, [estanciaData])

    const renderEstancia = (estancia) => {
        if (!estancia || (!estancia.minutos && estancia.minutos !== 0)) {
            return "";
        }
        const minutosLabel = estancia.minutos === 1 ? 'minuto' : 'minutos';
        const horasLabel = estancia.horas === 1 ? 'hora' : 'horas';
        const diasLabel = estancia.dias === 1 ? 'día' : 'días';
        var estanciaText = `${estancia.minutos} ${minutosLabel}`;
        if (estancia.horas > 0) {
            estanciaText = `${estancia.horas} ${horasLabel}, ${estanciaText}`;
        }
        if (estancia.dias > 0) {
            estanciaText = `${estancia.dias} ${diasLabel}, ${estanciaText}`;
        }
        return estanciaText;
    }

    const handleExited = () => {
        navigate(-1);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const title = 'Detalle estancia';

    return (
        <>
            <BaseDialog open={open} onExited={handleExited} title={title} onClose={handleClose} fullWidth
                actions={
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button onClick={handleClose} color="primary">Cerrar</Button>
                    </Box>
                }>
                <Box>
                    {loadingEstancia && <LoadingSkeleton />}
                    {estancia &&
                        <>
                            <DataLabel label="Tag" value={`${tag.prefijo} ${tag.numero} (${estancia.tipoEstancia})`} />
                            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Panel>
                                        <Typography align="center" sx={{ fontWeight: 450 }}>Entrada</Typography>
                                        <DataLabel label="Fecha" value={formatDateInYear(estancia.entrada.fechaHora, 'MMM D', ' HH:mm', ', YYYY')} gutterBottom />
                                        <DataLabel label="Carril" value={estancia.entrada.nombreCarril} gutterBottom />
                                        <DataLabel label="Descripción" value={estancia.entrada.descripcion} />
                                    </Panel>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Panel>
                                        <Typography align="center" sx={{ fontWeight: 450 }}>Salida</Typography>
                                        <DataLabel label="Fecha" value={formatDateInYear(estancia.salida.fechaHora, 'MMM D', ' HH:mm', ', YYYY')} gutterBottom />
                                        <DataLabel label="Carril" value={estancia.salida.nombreCarril} gutterBottom />
                                        <DataLabel label="Descripción" value={estancia.salida.descripcion} />
                                    </Panel>
                                </Grid>
                            </Grid>
                            {estancia.salida.confirmado &&
                                <DataLabel label="Tiempo de estancia" value={renderEstancia(estancia.tiempoEstancia)} />
                            }
                            {(estancia.entrada && estancia.entrada.confirmado) && !estancia.salida.confirmado &&
                                <DataLabel label="Tiempo transcurrido" value={renderEstancia(estancia.tiempoEstancia)} />
                            }
                            {estancia.fechaHoraEntradaNido &&
                                <Panel sx={{ mt: 2 }}>
                                    <Typography align="center" sx={{ fontWeight: 450 }}>Estancia nido</Typography>
                                    <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Panel variant="level1">
                                                <Typography align="center" sx={{ fontWeight: 450 }}>Entrada</Typography>
                                                <DataLabel label="Fecha" value={formatDateInYear(estancia.fechaHoraEntradaNido, 'MMM D', ' HH:mm', ', YYYY')} gutterBottom />
                                                <DataLabel label="Descripción" value={estancia.mensajeEntradaNido} />
                                            </Panel>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Panel variant="level1">
                                                <Typography align="center" sx={{ fontWeight: 450 }}>Salida</Typography>
                                                <DataLabel label="Fecha" value={formatDateInYear(estancia.fechaHoraSalidaNido, 'MMM D', ' HH:mm', ', YYYY')} gutterBottom />
                                                <DataLabel label="Descripción" value={estancia.mensajeSalidaNido} />
                                            </Panel>
                                        </Grid>
                                    </Grid>
                                    {estancia.fechaHoraSalidaNido &&
                                        <DataLabel label="Tiempo total en nido" value={renderEstancia(estancia.tiempoEstanciaNido)} />
                                    }
                                    {!estancia.fechaHoraSalidaNido &&
                                        <DataLabel label="Tiempo transcurrido en nido" value={renderEstancia(estancia.tiempoEstanciaNido)} />
                                    }
                                </Panel>
                            }
                        </>
                    }
                </Box>
            </BaseDialog>
        </>
    );
}

export default DetalleEstanciaDialog;